import { Apps, FilterList, ViewList } from "@mui/icons-material";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import ProductFilterCard from "../../product-details/default/product-filter-card";
import SalifyFallback from "../../salify-fallback/default";
import { H5, Paragraph } from "../../salify-next-layout/default/components/Typography";
import { FlexBox } from "../../salify-next-layout/default/components/flex-box";
import { SideNav } from "../../salify-next-layout/default/components/side-nav";

const SearchResultControl: React.FC<{
  search: string;
  quantity: number;
  orderBy: string;
  orderByOptions: Array<{ value: string; label: string }>;
  currentView: string;
  toggleView: (view: string) => () => void;
}> = ({ search, quantity, orderBy, orderByOptions, currentView, toggleView }) => (
  <Card
    elevation={1}
    sx={{
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "space-between",
      background: "inherit",
      border: "none",
      boxShadow: "none",
    }}
  >
    <div>
      <H5 fontWeight="normal">
        {search ? (
          <SalifyFallback.LabelTemplate
            path="titleWithSearch"
            default="{{quantity}} results for <b>{{q}}</b>"
            params={{ quantity: quantity ?? 0, q: search }}
            render={(value) => <div dangerouslySetInnerHTML={{ __html: value }} />}
          />
        ) : (
          <SalifyFallback.Label path="title" default="Collection" />
        )}
      </H5>
    </div>

    <FlexBox alignItems="center" columnGap={4} flexWrap="wrap" my="0.5rem">
      <FlexBox alignItems="center" gap={1} flex="1 1 0">
        <Paragraph color="grey.600" whiteSpace="pre">
          <SalifyFallback.Label path="sortBy" default="Sort by" />:
        </Paragraph>

        <TextField
          select
          fullWidth
          size="small"
          variant="outlined"
          placeholder="Sort by"
          defaultValue={orderBy}
          sx={{
            flex: "1 1 0",
            minWidth: "150px",
            background: "white",
          }}
        >
          {orderByOptions?.map((item) => (
            <MenuItem value={item.value} key={item.value}>
              {item.label}
            </MenuItem>
          ))}
        </TextField>
      </FlexBox>

      <FlexBox alignItems="center" my="0.25rem">
        <Paragraph color="grey.600" mr={1}>
          View:
        </Paragraph>

        <IconButton onClick={toggleView("grid")}>
          <Apps color={currentView === "grid" ? "primary" : "inherit"} fontSize="small" />
        </IconButton>

        <IconButton onClick={toggleView("list")}>
          <ViewList color={currentView === "list" ? "primary" : "inherit"} fontSize="small" />
        </IconButton>

        {/* SHOW IN THE SMALL DEVICE */}
        <Box display={{ xs: "block", md: "none" }}>
          <SideNav
            handle={
              <IconButton>
                <FilterList fontSize="small" />
              </IconButton>
            }
          >
            <ProductFilterCard shouldHideFilters={quantity <= 0} />
          </SideNav>
        </Box>
      </FlexBox>
    </FlexBox>
  </Card>
);

export default SearchResultControl;
